import { useEffect } from "react";
import { useTranslation } from "react-i18next";

const useNoDataText = () => {
	const { t } = useTranslation();

	useEffect(() => {
		let observer: MutationObserver | null = null;
		let interval: NodeJS.Timeout | null = null;

		const updateText = () => {
			document.querySelectorAll(".rs-table-body-info").forEach((el) => {
				if (
					el.textContent === "No data found" &&
					el.textContent !== t("noDataFound")
				) {
					el.textContent = t("noDataFound");
				}
			});
		};

		const attachObserver = (target: Element) => {
			observer = new MutationObserver(updateText);
			observer.observe(target, { childList: true, subtree: true });
			updateText();
		};

		const tryAttach = () => {
			const found = document.querySelector(".rs-table");
			if (found) {
				attachObserver(found);
				if (interval) clearInterval(interval);
			}
		};

		tryAttach();
		interval = setInterval(tryAttach, 100);

		return () => {
			if (observer) observer.disconnect();
			if (interval) clearInterval(interval);
		};
	}, [t]);
};

export default useNoDataText;

// import { useEffect } from "react";
// import { useTranslation } from "react-i18next";

// const useNoDataText = () => {
// 	const { t } = useTranslation();

// 	useEffect(() => {
// 		let observer: MutationObserver | null = null;

// 		const updateText = () => {
// 			const el = document.querySelector(".rs-table-body-info");
// 			if (el && el.textContent !== t("noDataFound")) {
// 				el.textContent = t("noDataFound");
// 			}
// 		};

// 		updateText();

// 		const tableContainer = document.querySelector(".rs-table");
// 		if (tableContainer) {
// 			observer = new MutationObserver(() => updateText());
// 			observer.observe(tableContainer, {
// 				childList: true,
// 				subtree: true,
// 			});
// 		}

// 		return () => {
// 			if (observer) observer.disconnect();
// 		};
// 	}, [t]);
// };

// export default useNoDataText;

// const useNoDataText = () => {
// 	const { t } = useTranslation();

// 	useEffect(() => {
// 		let observer: MutationObserver | null = null;
// 		let interval: NodeJS.Timeout | null = null;

// 		const updateText = () => {
// 			const els = document.querySelectorAll(".rs-table-body-info");
// 			els.forEach((el) => {
// 				if (el.textContent !== t("noDataFound")) {
// 					el.textContent = t("noDataFound");
// 				}
// 			});
// 		};

// 		const tableContainer = document.querySelector(".rs-table");
// 		if (tableContainer) {
// 			observer = new MutationObserver(updateText);
// 			observer.observe(tableContainer, {
// 				childList: true,
// 				subtree: true,
// 			});
// 			updateText();
// 		} else {
// 			interval = setInterval(() => {
// 				const found = document.querySelector(".rs-table");
// 				if (found) {
// 					updateText();
// 					observer = new MutationObserver(updateText);
// 					observer.observe(found, { childList: true, subtree: true });
// 					clearInterval(interval!);
// 				}
// 			}, 100);
// 		}

// 		return () => {
// 			if (observer) observer.disconnect();
// 			if (interval) clearInterval(interval);
// 		};
// 	}, [t]);
// };
